export const getDomain = () => {
    let slug = "discoride";
    if (localStorage.getItem('idttSlug') != undefined) {
        slug = localStorage.getItem('idttSlug');
    }
    return `https://futuro.projet-matthew.fr/`;
    // return 'http://127.0.0.1:8000/';
}

export const getDomainPublic = () => {
    let slug = "discoride";
    if (localStorage.getItem('idttSlug') != undefined) {
        slug = localStorage.getItem('idttSlug');
    }
    return `https://${slug}.fr/`;
    // return 'http://localhost:3000/';
}

export const config = {
    headers: {
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Credentials':'true',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
    }
}

export const tempAlWait = () => {
    return {
        active: true,
        type: 'warning',
        title: "Analyse des données...",
        desc: "Analyse des données en cours."
    }
}

// Alert basique
export const tempAlErr = (code) => {
    return {
        active: true,
        type: 'err',
        title: `Une erreur est survenue (Code : ${code})`,
        desc: "Une erreur est survenue, veuillez contacter l'administrateur du site."
    }
}

// Format date 01 Janvier
export const dispDateMonth = (date) => {
    let res = "";

    let tempDate = new Date(date);
    let tempDay = tempDate.getDate() < 10 ? `0${tempDate.getDate()}` : tempDate.getDate();
    let months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    let tempMonth = months[tempDate.getMonth()];
    res = `${tempDay} ${tempMonth}`;

    return res;
}

// Format date heure 01/01/2025 à 12h00
export const dispDateHour = (date) => {
    let res = "";
    let tempDate = new Date(date);
    let tempDay = tempDate.getDate() < 10 ? `0${tempDate.getDate()}` : tempDate.getDate();
    let tempMonth = tempDate.getMonth() + 1;
    tempMonth = tempMonth < 10 ? `0${tempMonth}` : tempMonth;
    let tempYear = tempDate.getFullYear();

    let tempHour = tempDate.getHours() < 10 ? `0${tempDate.getHours()}` : tempDate.getHours();
    let tempMin = tempDate.getMinutes() < 10 ? `0${tempDate.getMinutes()}` : tempDate.getMinutes();
    
    res = `${tempDay}/${tempMonth}/${tempYear} à ${tempHour}h${tempMin}`;

    return res;
}

// Initial state
export const initalState = {
    alert: {
        acitve: false,
        type: '',
        title: '',
        desc: ''
    }
}

// Initial state datas array
export const initialStateDatasArray = {
    alert: {
        active: false,
        type: '',
        title: '',
        desc: ''
    },
    datas: []
}

// Initial state datas data
export const initialSTateDatasData = {
    alert: {
        active: false,
        type: '',
        title: '',
        desc: ''
    },
    datas: null
}

// Initial state next
export const initialStateNext = {
    alert: {
        active: false,
        type: '',
        title: '',
        desc: ''
    },
    isNext: false
}

// Obtenir l'id dans l'url
export const getIdInUrl = () => {
    let queryString = window.location.pathname;
    let params = queryString.split("/");
    let productId = params[params.length - 1];
    return productId;
}